// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"401":"a702cc46","657":"0da5d466","905":"889a9dc0"}[chunkId] + ".chunk.css";
};